export default __webpack_public_path__ + "static/realWorldImg2-eee537d83136165c3d6688f865dbe9b5.webp";